var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: _vm.dialogWidth },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.onenter.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "resizable-card",
          class: { "no-select": _vm.resizing },
          style: { height: _vm.dialogHeight + "px" },
        },
        [
          _c(
            "v-card-title",
            [
              _c("span", { staticClass: "headline" }, [
                _vm._v("Tutorial (" + _vm._s(this.rules.name) + ")"),
              ]),
              _c("v-spacer"),
              _c("r-authorize", {
                attrs: {
                  master: _vm.masterAccess,
                  locked: _vm.model.locked,
                  enabled: _vm.model.enabled,
                },
                on: {
                  "update:locked": function ($event) {
                    return _vm.$set(_vm.model, "locked", $event)
                  },
                  "update:enabled": function ($event) {
                    return _vm.$set(_vm.model, "enabled", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "v-col",
                { attrs: { cols: "4", sm: "2", md: "2" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-2",
                      attrs: { small: "" },
                      on: {
                        click: function ($event) {
                          return _vm.showPreview()
                        },
                      },
                    },
                    [_vm._v("View JSON")]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "mb-n5",
                      attrs: { cols: "12", md: "12", sm: "12" },
                    },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "ID:", outlined: "", dense: "" },
                        model: {
                          value: _vm.model.id,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "id",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.id",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Name:" },
                        model: {
                          value: _vm.model.name,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "name",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("v-text-field", {
                        directives: [
                          { name: "ascii-only", rawName: "v-ascii-only" },
                        ],
                        attrs: { label: "Key:" },
                        model: {
                          value: _vm.model.key,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.model,
                              "key",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "model.key",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "3", sm: "3" } },
                    [
                      _c("v-checkbox", {
                        attrs: { label: "V2", "hide-details": "" },
                        model: {
                          value: _vm.model.v2,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "v2", $$v)
                          },
                          expression: "model.v2",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "3", sm: "3" } },
                    [
                      _c("v-checkbox", {
                        attrs: { label: "Master", "hide-details": "" },
                        model: {
                          value: _vm.model.master,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "master", $$v)
                          },
                          expression: "model.master",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "6", md: "6" } },
                    [
                      _c("r-tutorial-dropdown", {
                        attrs: {
                          model: _vm.model.showNext,
                          label: "Show Next",
                          clearable: true,
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "showNext", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "mt-3",
                      attrs: { cols: "12", md: "12", sm: "12" },
                    },
                    [_c("v-divider")],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "6", sm: "6" } },
                    [
                      _c("r-tutorial-kind", {
                        attrs: { model: _vm.model.kind, label: "Type:" },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "kind", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2", sm: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Delay Show", "hide-details": "" },
                        model: {
                          value: _vm.model.delayOnShow,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "delayOnShow", _vm._n($$v))
                          },
                          expression: "model.delayOnShow",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2", sm: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Auto Close", "hide-details": "" },
                        model: {
                          value: _vm.model.autoClose,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "autoClose", _vm._n($$v))
                          },
                          expression: "model.autoClose",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "2", sm: "2" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Priority", "hide-details": "" },
                        model: {
                          value: _vm.model.priority,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "priority", _vm._n($$v))
                          },
                          expression: "model.priority",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4", sm: "4" } },
                    [
                      _c("v-checkbox", {
                        attrs: {
                          disabled: !_vm.model.v2,
                          label: "Light Mode",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.model.lightMode,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "lightMode", $$v)
                          },
                          expression: "model.lightMode",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4", sm: "4" } },
                    [
                      _c("v-checkbox", {
                        attrs: { label: "Strict Mode", "hide-details": "" },
                        model: {
                          value: _vm.model.strict,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "strict", $$v)
                          },
                          expression: "model.strict",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4", sm: "4" } },
                    [
                      _c("v-checkbox", {
                        attrs: { label: "Focus Camera", "hide-details": "" },
                        model: {
                          value: _vm.model.camera,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "camera", $$v)
                          },
                          expression: "model.camera",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4", sm: "4" } },
                    [
                      _c("v-checkbox", {
                        attrs: { label: "Ignore Popup", "hide-details": "" },
                        model: {
                          value: _vm.model.ignorePopup,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "ignorePopup", $$v)
                          },
                          expression: "model.ignorePopup",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4", sm: "4" } },
                    [
                      _c("v-checkbox", {
                        attrs: { label: "Over Notice", "hide-details": "" },
                        model: {
                          value: _vm.model.overNotice,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "overNotice", $$v)
                          },
                          expression: "model.overNotice",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4", sm: "4" } },
                    [
                      _c("v-checkbox", {
                        attrs: { label: "Shared", "hide-details": "" },
                        model: {
                          value: _vm.model.shared,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "shared", $$v)
                          },
                          expression: "model.shared",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4", sm: "4" } },
                    [
                      _c("v-checkbox", {
                        attrs: {
                          disabled: !_vm.model.v2,
                          label: "Blocked by V1",
                          "hide-details": "",
                        },
                        model: {
                          value: _vm.model.blockedByV1,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "blockedByV1", $$v)
                          },
                          expression: "model.blockedByV1",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4", sm: "4" } },
                    [
                      _c("v-checkbox", {
                        attrs: { label: "Hides Dialogs", "hide-details": "" },
                        model: {
                          value: _vm.model.hidesDialogs,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "hidesDialogs", $$v)
                          },
                          expression: "model.hidesDialogs",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c("v-col", { attrs: { cols: "12", md: "12", sm: "12" } }, [
                    _c("br"),
                  ]),
                  _c(
                    "v-expansion-panels",
                    [
                      _c(
                        "v-expansion-panel",
                        [
                          _c("v-expansion-panel-header", {
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function ({ open }) {
                                  return [
                                    _c(
                                      "v-row",
                                      { attrs: { "no-gutters": "" } },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              "margin-top": "5px",
                                            },
                                          },
                                          [_vm._v("Configs")]
                                        ),
                                        _c("v-spacer"),
                                        _c("v-fade-transition", [
                                          open
                                            ? _c(
                                                "span",
                                                {
                                                  staticStyle: {
                                                    display: "inline-flex",
                                                  },
                                                },
                                                [
                                                  _c("v-divider", {
                                                    staticClass: "mx-1",
                                                    attrs: { vertical: "" },
                                                  }),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ]),
                                      ],
                                      1
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _c(
                            "v-expansion-panel-content",
                            [
                              _c(
                                "v-row",
                                { attrs: { dense: "" } },
                                [
                                  _c(
                                    "v-col",
                                    { attrs: { cols: "12", sm: "6", md: "6" } },
                                    [
                                      _c("r-item-dropdown", {
                                        attrs: { model: _vm.model.item },
                                        on: {
                                          "update:model": function ($event) {
                                            return _vm.$set(
                                              _vm.model,
                                              "item",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    {
                                      attrs: { cols: "12", md: "12", sm: "12" },
                                    },
                                    [
                                      _c("r-cell-config-table", {
                                        attrs: {
                                          items: _vm.model.cells,
                                          title: "Cells",
                                        },
                                        on: {
                                          "update:items": function ($event) {
                                            return _vm.$set(
                                              _vm.model,
                                              "cells",
                                              $event
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("r-guard-panel", {
                        attrs: {
                          model: _vm.model.guard,
                          title: "Guard Config",
                        },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "guard", $event)
                          },
                        },
                      }),
                      _c("r-trigger-panel", {
                        attrs: {
                          items: _vm.model.triggersAvailable,
                          title: "Triggers - Available",
                        },
                        on: {
                          "update:items": function ($event) {
                            return _vm.$set(
                              _vm.model,
                              "triggersAvailable",
                              $event
                            )
                          },
                        },
                      }),
                      _c("r-trigger-panel", {
                        attrs: {
                          items: _vm.model.triggersComplete,
                          title: "Triggers - Complete",
                        },
                        on: {
                          "update:items": function ($event) {
                            return _vm.$set(
                              _vm.model,
                              "triggersComplete",
                              $event
                            )
                          },
                        },
                      }),
                      _c(
                        "r-panel",
                        { attrs: { title: "Map Group" } },
                        [
                          _c("r-map-group-dropdown", {
                            attrs: { model: _vm.model.mapGroup },
                            on: {
                              "update:model": function ($event) {
                                return _vm.$set(_vm.model, "mapGroup", $event)
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              !_vm.lockedAssess || _vm.masterAccess
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: { click: _vm.save },
                    },
                    [_vm._v(" Save ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("div", {
            staticClass: "resize-handle",
            on: {
              mousedown: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.startResize.apply(null, arguments)
              },
            },
          }),
          _c("r-preview-dialog", { ref: "preview-dialog" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }